import { handleFieldChange } from "../../../../Utils";
import { Button } from 'react-bootstrap';

import React from 'react';

import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from "../../../../components/SelectWrap";

import config from "../../config";

const Spacer = (props) => <div style={{marginTop: props.marginTop}}></div>;

class Form extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.handle_submit = this.handle_submit.bind(this);
        this.handle_field_change = handleFieldChange.bind(this);
    }

    componentDidMount() {
        console.log(this.props);

        if (this.props && this.props.entity) {
            this.setState({ ...this.state, ...this.props.entity });
        }
    }

    handle_submit(event) {
        event.preventDefault();

        if (this.state.id) this.props.on_edit({ ...this.state });
        else this.props.on_create({ ...this.state });
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.on_hide}>
                <form onSubmit={this.handle_submit} style={{ height: 'auto', maxWidth: "600px", overflow: 'hidden' }}>
                    <FieldGroup
                        name="type"
                        label="Type:"
                        onChange={this.handle_field_change}
                        value={this.state.type}
                        disabled={this.state.update}
                        required
                    />

                    <Spacer marginTop={'15px'} />

                    <FieldGroup
                        name="domain"
                        label="Domain:"
                        onChange={this.handle_field_change}
                        value={this.state.domain}
                        required
                    />

                    <Spacer marginTop={'15px'} />

                    <SelectWrap
                        value={this.state.virustotal_configuration}
                        name="virustotal_configuration"
                        label="VirusTotal Configuration:"
                        values={config.virustotal_configuration}
                        onChange={this.handle_field_change}
                    />

                    <Spacer marginTop={'15px'} />

                    <FieldGroup
                        name="virustotal_threshold"
                        label="VirusTotal Threshold:"
                        onChange={this.handle_field_change}
                        value={this.state.virustotal_threshold}
                        type={'number'}
                        step={'1'}
                    />

                    <Button style={{ marginTop: '50px' }} className="pull-right" bsStyle="success" type="submit">Save</Button>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;



// WEBPACK FOOTER //
// ./src/scenes/AdkPartnerDomains/components/Form/index.js